export const saveBlobAsFile = (blobData: Blob, fileName: string) => {
  const file = new File([blobData], fileName);
  const url = window.URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
};

export const downloadFile = (data: Blob, fileName: string): void => {
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;

  const now = new Date();
  const datePart = now.toLocaleDateString("ru-RU");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");

  a.download = `${fileName} ${datePart}, ${hours}:${minutes}.xlsx`;
  document.body.appendChild(a);
  a.click();

  URL.revokeObjectURL(url);
  document.body.removeChild(a);
};
